module.exports = __webpack_public_path__ + "static/img/bxtLogo.f3a1c53b.png";